<!-- TODO PROTRACTOR: Leaving class page-header so protractor tests dont break -->
<div class="flex flex-wrap pl-4 mx-0 my-6 page-header">
  <a
    mat-stroked-button
    [routerLink]="backRoute"
    [queryParamsHandling]="preserveQueryParam ? 'preserve' : ''"
    class="mr-3"
    *ngIf="isBackBtnShown"
  >
    <mat-icon aria-label="Back">arrow_back</mat-icon>
  </a>
  <h1 class="text-3xl font-bold font-montserrat text-project-500">
    {{ title }}
  </h1>
  <div class="flex self-end justify-end flex-1">
    <ng-content></ng-content>
  </div>
</div>
